import React, { FC, useMemo } from "react"
import styled from "styled-components"

import { preventSleepyBuddies } from "@utils"
import { MEDIA_QUERIES } from "@constants"

import NewsletterForm from "@components/HubspotForm/presets/NewsletterForm"
import { BespokeComponentFragmentFragment } from "@graphqlTypes"

export const NewsletterFullWidthCtaSECTION = styled.section`
  background: var(--color--slate-100);
  padding: var(--spacing--L) 0;
  margin: 0 0 var(--spacing--L);

  .grid {
    align-items: center;
  }

  .content {
    h3,
    p {
      text-wrap: balance;
    }
  }

  .Row {
    align-items: flex-start;
  }

  ${MEDIA_QUERIES.L} {
    .HubspotForm {
      position: relative;
    }

    .privacy-text {
      position: absolute;
      bottom: calc(var(--font-size--XS) * var(--line-height--relaxed) * -1 - var(--spacing--XS));
    }
  }
`

type NewsletterFullWidthCtaJsonPayload = {
  overline: string,
  title: string,
  paragraph: string,
}

const NewsletterFullWidthCta: FC<{
  contentful_id: BespokeComponentFragmentFragment["contentful_id"]
  jsonPayload: BespokeComponentFragmentFragment["jsonPayload"]
}> = ({
  contentful_id,
  jsonPayload,
}) => {
    const json = useMemo(() => {
      try {
        return JSON.parse(jsonPayload?.internal.content || "") as NewsletterFullWidthCtaJsonPayload
      } catch (e) {
        console.error(`Failed to parse JSON Payload: NewsletterFullWidthCta (${contentful_id})`)
        return null
      }
    }, [jsonPayload])

    if (!json) return null

    return (
      <NewsletterFullWidthCtaSECTION>
        <div className="container">
          <div className="grid">
            <div className="content column column--1-9-M column--1-7-L">
              <h4 className="type--mono-L color--text-default" dangerouslySetInnerHTML={{ __html: json.overline }} />
              <h3 dangerouslySetInnerHTML={{ __html: preventSleepyBuddies(json.title) }} />
              <p className="type--text-L" dangerouslySetInnerHTML={{ __html: preventSleepyBuddies(json.paragraph) }} />
            </div>
            <div className="column column--1-12-M column--7-13-L">
              <NewsletterForm />
            </div>
          </div>
        </div>
      </NewsletterFullWidthCtaSECTION>
    )
  }

export default NewsletterFullWidthCta
